export const signalEmbedRoutes = [
    {
        path: '/signal-embed',
        components: {
            default: () => import('@/features/signal-embed/views/SignalEmbedRouterView.vue'),
        },
        children: [
            {
                path: '',
                components: {
                    default: () => import('@/features/signal-embed/views/SignalEmbedIndexView.vue'),
                },
                name: 'signal-embed',
                redirect: { name: 'signal-embed-new' },
            },
            {
                path: 'new',
                name: 'signal-embed-new',
                component: () => import('@/features/signal/views/SignalPlaceholderView.vue'),
            },
            {
                path: ':id/:mode?',
                name: 'signal-embed-show',
                component: () => import('@/features/signal/views/SignalPlaceholderView.vue'),
            },

            // ── Legacy URL redirect ───────────────────────────────────────────────
            // Old shape: /signal-embed/:mode/:signalId  →  new shape: /signal-embed/:id/:mode
            {
                path: ':mode([a-z-]+)/:id',
                redirect: (to) => ({
                    name: 'signal-embed-show',
                    params: { id: to.params.id, mode: to.params.mode },
                }),
            },
        ],
    },
]
